.overlay {
    position: fixed;
    inset: 0;
    background-color: rgba(15, 23, 42, 0.55);
    backdrop-filter: blur(2px);
    -webkit-backdrop-filter: blur(2px);
    display: flex;
    align-items: flex-start;
    justify-content: center;
    padding: max(10vh, var(--tempest-safe-area-top)) var(--tempest-space-4) var(--tempest-space-4)
        var(--tempest-space-4);
    z-index: var(--tempest-z-modal);
    animation: tempest-fade-in var(--tempest-duration-base) var(--tempest-ease-out);
}

.dialog {
    background-color: var(--tempest-bg);
    color: var(--tempest-text);
    border-radius: var(--tempest-radius-xl);
    box-shadow: var(--tempest-shadow-xl);
    border: 1px solid var(--tempest-border);
    width: 100%;
    max-width: 640px;
    max-height: 70vh;
    max-height: 70dvh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    animation: tempest-modal-in var(--tempest-duration-base) var(--tempest-ease-emphasized);
}

.inputRow {
    display: flex;
    align-items: center;
    gap: var(--tempest-space-3);
    padding: var(--tempest-space-4) var(--tempest-space-5);
    border-bottom: 1px solid var(--tempest-border);
}

.searchIcon {
    color: var(--tempest-text-muted);
    flex-shrink: 0;
}

.input {
    flex: 1;
    min-width: 0;
    border: none;
    outline: none;
    background: transparent;
    color: var(--tempest-text);
    font-size: var(--tempest-text-base);
    line-height: var(--tempest-leading-normal);
}

.input::placeholder {
    color: var(--tempest-text-muted);
}

.list {
    list-style: none;
    margin: 0;
    padding: var(--tempest-space-2);
    overflow-y: auto;
}

.group {
    list-style: none;
}

.group + .group {
    margin-top: var(--tempest-space-2);
}

.groupHeading {
    padding: var(--tempest-space-2) var(--tempest-space-3);
    font-size: var(--tempest-text-xs);
    font-weight: var(--tempest-weight-semibold);
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: var(--tempest-text-muted);
}

.groupList {
    list-style: none;
    margin: 0;
    padding: 0;
}

.option {
    display: flex;
    align-items: center;
    gap: var(--tempest-space-3);
    padding: var(--tempest-space-2) var(--tempest-space-3);
    border-radius: var(--tempest-radius-md);
    cursor: pointer;
    color: var(--tempest-text);
    transition: var(--tempest-transition-color);
}

.option.active {
    background-color: var(--tempest-primary-soft);
    color: var(--tempest-primary-on-soft);
    box-shadow: inset 3px 0 0 0 var(--tempest-selected-indicator);
}

.icon {
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--tempest-text-muted);
    flex-shrink: 0;
}

.label {
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.empty {
    list-style: none;
    padding: var(--tempest-space-6) var(--tempest-space-3);
    text-align: center;
    color: var(--tempest-text-muted);
    font-size: var(--tempest-text-sm);
}

@keyframes tempest-fade-in {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

@keyframes tempest-modal-in {
    from {
        opacity: 0;
        transform: translateY(-12px) scale(0.98);
    }
    to {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
}

@media (prefers-reduced-motion: reduce) {
    .overlay,
    .dialog {
        animation: none;
    }
}
